export const formatTextToUnorderedList = (text: string) => {
  const listItems = text.split('\n').map((item) => `<li>${item}</li>`);
  const listHtml = `<ul style="text-align: justify; list-style-type: disc;">${listItems.join(
    ''
  )}</ul>`;

  return listHtml;
};

export const formatTextToOrderedList = (text: string) => {
  const listItems = text.split('\n').map((item) => `<li>${item}</li>`);
  const listHtml = `<ol style="text-align: justify; list-style-type: decimal;">${listItems.join(
    ''
  )}</ol>`;

  return listHtml;
};
